export const ACCOUNT_TAGS_OPEN_CLOSE_DELETE_TAGS_MODAL = "ACCOUNT_TAGS_OPEN_CLOSE_DELETE_TAGS_MODAL";

export const ACCOUNT_TAGS_DELETE_TAGS = "ACCOUNT_TAGS_DELETE_TAGS";
export const ACCOUNT_TAGS_DELETE_TAGS_RESPONSE = "ACCOUNT_TAGS_DELETE_TAGS_RESPONSE";